define( function() {
	"use strict";

	return window.location;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/ajax/var/location.js
// module id = 2309
// module chunks = 36